/**
self()
Returns `this`.
*/

export default function self() { return this; }
